<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[1]" :innerTitle="navList[1].navChildList[3].name" :innerLink="navList[1].navChildList[3].toLink"></inner-nav>
      <div class="team-content">
        <div class="team-title">
          <h1>团队介绍</h1>
          <h3>team introduction</h3>
        </div>
        <div class="team-list">
          <ul>
            <li v-for="(item,index) in teamList">
              <i></i>
              <div class="information">
                <div>
                  <img :src="item.imgUrl" alt="">
                </div>
                <div>
                  <p>{{item.userName}}</p>
                  <span>{{item.job}}</span>
                </div>
              </div>
              <div class="introduction">
                {{item.content | delHtmlTag}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        teamList:{}
      }
    },
    filters: {
      delHtmlTag(str){
        if (str){
          var s=str.replace(/<[^>]*>|/g,"");
          return s.replace(/&nbsp;/ig, "");//去掉所有的html标记
        }
      }
    },
    components: {
      ad,
      InnerNav
    },
    created(){
      this.$http.get(`/outer/feifan/listTeams.do`).then((res)=>{
          this.teamList=res.data.list
      })
    }
  }
</script>

<style scoped lang="less">
  .team-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .team-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .team-list{
        width:12rem;
        border-bottom: .01rem solid #ccc;
          li{
            position: relative;
            width:100%;
            height:3rem;
            font-family:PingFangSC-Medium;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding: .5rem 1rem;
            border: .01rem solid #ccc;
            border-bottom:0;
              i{
                position: absolute;
                top:0;
                left:-.01rem;
                background: rgba(245,58,55,1);
                width:.03rem;
                height:0rem;
                transition: height .6s ease;
                -webkit-transition: height .6s ease;/* Safari */

              }
              .information{
                overflow: hidden;
                clear: both;
                width:100%;
                  div:nth-child(1){
                    float: left;
                    width:.8rem;
                    height:.8rem;
                    -webkit-border-radius:50%;
                    -moz-border-radius:50%;
                    border-radius:50%;
                    overflow: hidden;
                      img{
                        width:100%;
                        height:100%;
                      }
                  }
                  div:nth-child(2){
                    padding: .2rem ;
                    float: left;
                      p{
                        font-size:.20rem;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                        line-height:.20rem;
                      }
                      span{
                        font-size:.14rem;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:.14rem;
                      }
                  }
              }
              .introduction{
                padding-top: .36rem;
                font-size:.14rem;
                text-align: justify;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:.24rem;
                overflow: hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-line-clamp:3;
                -webkit-box-orient:vertical;
                position:relative;
                max-height:.72rem;
              }
          }
          li:hover{
           i{
             height:100%;
           }
          }
      }

  }



</style>



// WEBPACK FOOTER //
// src/pages/group/team.vue